import TrackString from "../../../analytics/TrackString";
import AbstractCommand from "../../../core/application/AbstractCommand";
import NavigateEvent from "../../../core/navigation/NavigateEvent";
import SkinFactory from "../../../core/ui/SkinFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import ScenarioPlayerEvent from "../../scenario/ScenarioPlayerEvent";
import NGTDialogFactory from "../NGTDialogFactory";
import NGTDialogPlayer from "../NGTDialogPlayer";
import DialogPlayerRegisterEvent from "./DialogPlayerRegisterEvent";
/**
 * PlayDialogCommand.js
 * 
 * Created on Oct 8, 2013, 3:36:48 PM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/
export default class PlayDialogCommand extends AbstractCommand {
    /**
     * 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {NGTDialogFactory} dialogFactory 
     * @param {NGTDialogPlayer} dialogPlayer 
     */
    constructor(dispatcher, dialogFactory, dialogPlayer) {
        super(dispatcher);
        this._dialogFactory = dialogFactory;
        this._dialogPlayer = dialogPlayer;

        this._handleContentCompletedBound = this._handleContentCompleted.bind(this);
    }

    execute(event) {
        const content = event.params.data.content;
        this._dialogPlayer.setContentPlayer(event.params.data.contentPlayer);
        this._dialogPlayer.setContent(content);

        const dialogId = content.getDialogID();
        const dialog = this._dialogFactory.getDialog(dialogId);
        this._dialogPlayer.setDialog(dialogId, dialog);

        const dprEvent = new DialogPlayerRegisterEvent(DialogPlayerRegisterEvent.REGISTER, this._dialogPlayer);
        this.dispatch(dprEvent.type, dprEvent);

        // Analytics: Sends dialog start
        this.trackEvent(TrackString.EVENT_DIALOG_START, TrackString.createDialogParams(dialogId));

        this._dialogPlayerSkin = SkinFactory.getSkin(SkinKeyRegistry.DIALOG_SCREEN_SKIN);
        this._dialogPlayerSkin["dialogPanel"].dialogPlayer = this._dialogPlayer;
        this._dialogPlayerSkin["dialogPlayer"] = this._dialogPlayer;
        this._dispatcher.addEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound, this);

        const commandEvent = new NavigateEvent(NavigateEvent.OPEN_SCREEN_REQUEST, this._dialogPlayerSkin.skinType, this._dialogPlayerSkin);
        this.dispatch(commandEvent.type, { data: commandEvent });

        this._startTime = Date.now();
        this._dialogPlayer.viewContent();
    }

    _handleContentCompleted({ params }) {
        if (params.data.content !== this._dialogPlayer.getContent()) {
            return;
        }

        const dialogId = params.data.content.getDialogID();
        const dprEvent = new DialogPlayerRegisterEvent(DialogPlayerRegisterEvent.DEREGISTER, this._dialogPlayer);
        this.dispatch(dprEvent.type, dprEvent);

        // Analytics: Sends dialog end
        this.trackEvent(TrackString.EVENT_DIALOG_END, TrackString.createDialogParams(dialogId));

        // Close the content.
        const commandEvent = new NavigateEvent(NavigateEvent.CLOSE_SCREEN_REQUEST, null, this._dialogPlayerSkin);
        this.dispatch(commandEvent.type, { data: commandEvent });
        this.destroy();
    }

    destroy() {
        this._dispatcher.removeEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound);
        this._dialogPlayer.destroy();
        this._dialogPlayer = null;
        this._dialogPlayerSkin = null;
    }
}